import { render, staticRenderFns } from "./BatchOrder.vue?vue&type=template&id=771e83fe&scoped=true"
import script from "./BatchOrder.vue?vue&type=script&lang=js"
export * from "./BatchOrder.vue?vue&type=script&lang=js"
import style0 from "./BatchOrder.vue?vue&type=style&index=0&id=771e83fe&prod&scoped=true&lang=scss"
import style1 from "./BatchOrder.vue?vue&type=style&index=1&id=771e83fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771e83fe",
  null
  
)

export default component.exports